import { render, staticRenderFns } from "./endpoints.vue?vue&type=template&id=e8e9e738&scoped=true"
import script from "./endpoints.vue?vue&type=script&lang=ts"
export * from "./endpoints.vue?vue&type=script&lang=ts"
import style0 from "./endpoints.vue?vue&type=style&index=0&id=e8e9e738&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e9e738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
